// Configuration mapping product IDs to image filenames
const imageConfig = {
  "1": "Coca-Cola-24-X-500ml.webp",
  "160": "westgate_popcorns.webp",
  "4223": "brt00204_01.jpg",
  "90": "27874_main.avif",
  "12": "171837-RAW-6-1697537014-300x300.jpg",
  "4173": "sweetzone-tangy-mix-90g.png",
  "5": "24172_main.avif",
  "13": "24952-Caramel-Popcorn-d.jpg",
  "350": "61xsruorzzl-sx679-1-copy-500x500.webp",
  "4": "24174_main.avif",
  "3070": "thumb_720_450_.jpg",
  "348": "Bounty-.png",
  "384": "m7bpk7uo6xk9.jpg",
  "2": "Sprite-Pet-Bottle-500ml.jpeg",
  "383": "downl5678hoad.jpeg",
  "3": "179847_1.avif",
  "73": "coca-cola-coke-zero-et-bottle-500ml.jpg",
  "3086": "hot-drink-paper-cup-500x500.webp",
  "385": "37165_Main.avif"
};

export default imageConfig;
